export default function getEnumLabel(key: string, theEnum: any, defaultLabel: string = '(unknown)'): string {
    return key in theEnum ? theEnum[key] : defaultLabel
}
